import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../common/models/Visiable";
import { FinanceState } from "../models/FinanceState";

const setVisiableExchangeForm = (state: FinanceState, action: PayloadAction<Visiable>) => {
    state.visiableExchangeForm = action.payload.visiable;
}

export default setVisiableExchangeForm;